/* eslint-disable no-restricted-syntax, no-prototype-builtins */
export default {
    /**
     * 将数据对象转换成Query对象，排除属性值为空字符串、false的属性
     * @param data 数据对象
     * @returns {object} Vue-Router的Query对象
     */
    query(data) {
        const query = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const value = data[key];
                if (value === 0 || value) {
                    query[key] = value;
                }
            }
        }
        return query;
    },

    /**
     * 将对象转换为查询字符串
     * @param data 数据
     * @returns {string} 查询字符串
     */
    queryString(data) {
        const qs = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const value = data[key];
                if (Array.isArray(value)) {
                    value.forEach((item) => qs.push(`${key}=${encodeURIComponent(item)}`));
                } else if (value === 0 || value) {
                    qs.push(`${key}=${encodeURIComponent(value)}`);
                }
            }
        }
        if (qs.length > 0) {
            return `?${qs.join('&')}`;
        }
        return '';
    },
};
